import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { api_url } from '../config/config';
import warn from "../images/warning.png";

const Animation = () => {
    return (
        <DotLottieReact
            src="https://lottie.host/81757755-4004-49f4-b9c8-4bbb4b23d5ff/MswlJJ9QgJ.lottie"
            loop
            autoplay
        />
    );
};

const LoginScreen = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalStep, setModalStep] = useState(1);
    const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [apiError, setApiError] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [mobileNumberEntered, setMobileNumberEntered] = useState(false);
    const [apiLoading, setApiLoading] = useState(false);
    const [otpToken, setOtpToken] = useState("");
    const navigate = useNavigate()

        const handleSubmit = async (e) => {
            e.preventDefault();
            setLoading(true);
            try {
                const response = await axios.post(`${api_url}/admin/login`, {
                    email,
                    password,
                });

            
                const { token, user, data } = response?.data || {};
                const userData = user || data || {};
                const permissions = userData?.permissions || data?.permissions || {};

                if (token) {
                
                    localStorage.setItem('admin_token', token);
                    localStorage.setItem('roles', userData.role);

                
                    switch (userData.role) {
                        case 'ADMIN': {
                            const ViewProducts = Boolean(
                                permissions?.Products ?? permissions?.products
                            );
                            navigate(
                                ViewProducts ? '/ng-admin/product-list' : '/ng-admin/',
                                { state: { user: userData } }
                            );
                            break;
                        }
                        case 'EMPLOYEE':
                            navigate('/ng-admin/', { state: { user: userData } });
                            break;
                        default:
                            navigate('/ng-admin/', { state: { user: userData } });
                    }
                } else {
                    toast.error('Login failed. No token received.', { position: "top-right" });
                }
            } catch (error) {
                toast.error(
                    error.response?.data?.message || 'Something went wrong!',
                    { position: "top-right" }
                );
            } finally {
                setLoading(false);
            }
        };

        const handleContinueCaution = async () => {
          setApiError("");
          setApiLoading(true);
          setModalStep(2);
          setApiLoading(false);
        };

        const handleCancelCaution = () => {
          setShowModal(false);
        };

        const handleOtpInputChange = (e, idx) => {
          const value = e.target.value.replace(/[^0-9]/g, "");
          if (value.length > 1) return; 
          const newDigits = [...otpDigits];
          newDigits[idx] = value;
          setOtpDigits(newDigits);
         
          if (value && idx < 5) {
            const nextInput = document.getElementById(`otp-input-${idx + 1}`);
            if (nextInput) nextInput.focus();
          }
        };

        const handleMobileNumberSubmit = async() => {
          if (mobileNumber.trim() === "") {
            setApiError("Please enter a valid mobile number.");
            return;
          }else if (mobileNumber.trim().length < 10) {
            setApiError("Mobile number must be 10 digits.");
            return;
          }
          try{
            const response = await axios.post(`${api_url}/forgot-password/generate-otp`, {
                mobile: mobileNumber,
            });

            if(response.status === 200){
                setOtpToken(response.data.otpToken);
                setModalStep(2);
                setMobileNumberEntered(true);
                setApiError("");
            }
          }catch(err){
            setApiError("Network error. Try again.");
          }
        };
        const handleOtpKeyDown = (e, idx) => {
          if (e.key === "Backspace" && !otpDigits[idx] && idx > 0) {
            const prevInput = document.getElementById(`otp-input-${idx - 1}`);
            if (prevInput) prevInput.focus();
          }
        };
        const handleOtpSave = async () => {
          setApiError("");
          setApiLoading(true);
          try {
            const res = await fetch(`${api_url}/forgot-password/verify-otp`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
              },
              body: JSON.stringify({
                otpToken,
                otp: otpDigits.join("")
              })
            });
            const data = await res.json();
            if (res.ok) {
              setModalStep(3);
            } else {
              setApiError(data?.message || "Invalid OTP.");
            }
          } catch (err) {
            setApiError("Network error. Try again.");
          } finally {
            setApiLoading(false);
          }
        setModalStep(3);
        setApiLoading(false);
        };
        const handlePasswordSave = async () => {
          setApiError("");
          setApiLoading(true);
          try {
            if (newPassword !== confirmPassword) {
              setApiError("Passwords do not match.");
              setApiLoading(false);
              return;
            }
            const res = await fetch(`${api_url}/forgot-password/update-password`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                 'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
              },
              body: JSON.stringify({
                otpToken,
                password: newPassword,
                confirmPassword: confirmPassword
              })
            });
            const data = await res.json();
            if (res.ok) {
              setShowModal(false);
              toast.success('Password updated successfully!');
            } else {
              setApiError(data?.message || "Failed to update password.");
            }
          } catch (err) {
            setApiError("Network error. Try again.");
          } finally {
            setApiLoading(false);
          }
        };
        const handleCloseModal = () => {
          setShowModal(false);
          setMobileNumber("");
          setMobileNumberEntered(false);
          setOtpDigits(["", "", "", "", "", ""]);
          setNewPassword("");
          setConfirmPassword("");
          setApiError("");
        };

        const handleResetPassword = () => {
        setShowModal(true);
        setModalStep(1);
        setOtpDigits(["", "", "", "", "", ""]);
        setNewPassword("");
        setConfirmPassword("");
        };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <ToastContainer />
            <div className="bg-white  rounded px-8 pt-6 pb-8 mb-4 w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>
                <div className=' flex justify-center'>
                    <Animation />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className='py-5'>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                required
                            />
                        </div>
                    </div>
                   <div className="mb-4 text-right">
                        <button
                            type="button"
                            onClick={handleResetPassword}
                            className="text-sm text-blue-500 hover:text-blue-700"
                        >
                            Forgot Password?
                        </button>
                    </div>
                    <div className="flex flex-col gap-4 items-center justify-between">
                        <button
                            type="submit"
                            className={`bg-[#5FBDB3]
  text-white rounded hover:bg-[#3d7b74] text-center w-full font-bold py-2 px-4  focus:outline-none focus:shadow-outline ${loading ? 'opacity-50 cursor-not-allowed ' : ''
                                }`}
                            disabled={loading}
                        >
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                        <Link to='/' className='w-full'>
                            <button
                                type="submit"
                                className={`bg-[#faffff]
        text-black rounded-lg hover:bg-[#f4f9f8] text-center  w-full border border-black font-medium py-2 px-4  focus:outline-none focus:shadow-outline ${loading ? 'opacity-50 cursor-not-allowed ' : ''
                                    }`}
                            >
                                Back To Website
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
                    {showModal && (
                      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-8 relative">
                          <button className="absolute top-2 right-2 w-6 h-6 text-gray-500 hover:text-gray-700" onClick={handleCloseModal}>&times;</button>
                      
                          {modalStep === 1 && (
                            <div className="text-center">
                              <div className="flex flex-col items-center justify-center mb-4">
                             <img src={warn} alt="Warning" className="w-16 h-16 mb-2" />
                                <h3 className="text-md font-semibold text-yellow-900">Are you sure you want to reset the password?</h3>
                              </div>
                              {apiError && <div className="text-red-600 mb-2">{apiError}</div>}
                              <div className="flex justify-center gap-4 mt-6">
                              <button className="bg-gray-300 text-gray-700 px-3 py-2 rounded" onClick={handleCancelCaution} disabled={apiLoading}>Cancel</button>
                                <button className="bg-green-600 text-white px-3 py-2 rounded" onClick={handleContinueCaution} disabled={apiLoading}>{apiLoading ? "Processing..." : "Continue"}</button>
                            
                              </div>
                            </div>
                          )} 
                      
                        {modalStep === 2 && (
                        <div>
                            {!mobileNumberEntered ? (
                            <>
                                <h3 className="text-lg font-semibold mb-4">Enter your mobile number</h3>
                                <input
                                type="tel"
                                className="border px-2 py-1 rounded w-full mb-4"
                                placeholder="Enter your mobile number"
                                value={mobileNumber}
                                onChange={e => {
                                    const cleaned = e.target.value.replace(/\D/g, "").slice(0, 10);
                                    setMobileNumber(cleaned);
                                }}
                                disabled={apiLoading}
                                />
                                {apiError && <div className="text-red-600 mb-2">{apiError}</div>}
                                <button
                                className="bg-green-600 text-white px-4 py-2 rounded w-full disabled:bg-gray-200 disabled:text-gray-400"
                                onClick={handleMobileNumberSubmit}
                                disabled={apiLoading || !mobileNumber}
                                >
                                {apiLoading ? "Processing..." : "Send OTP"}
                                </button>
                            </>
                            ) : (
                            <>
                                <h3 className="text-lg font-semibold mb-4">Please confirm the OTP below.</h3>
                                <div className="flex justify-center gap-3 mb-6">
                                {otpDigits.map((digit, idx) => (
                                    <input
                                    key={idx}
                                    id={`otp-input-${idx}`}
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={1}
                                    className="w-14 h-14 text-2xl text-center border border-gray-300 rounded focus:outline-none focus:border-green-600"
                                    value={digit}
                                    onChange={e => handleOtpInputChange(e, idx)}
                                    onKeyDown={e => handleOtpKeyDown(e, idx)}
                                    />
                                ))}
                                </div>
                                <button
                                className="bg-green-600 text-white px-4 py-2 rounded w-full disabled:bg-gray-200 disabled:text-gray-400"
                                onClick={handleOtpSave}
                                disabled={otpDigits.some(d => d === "")}
                                >
                                CONFIRM
                                </button>
                            </>
                            )}
                        </div>
                        )}

                      
                          {modalStep === 3 && (
                            <div>
                              <h3 className="text-lg font-semibold mb-4">Reset Password</h3>
                              <label className="block mb-2 text-gray-600">New Password</label>
                              <input
                                type="password"
                                className="border px-2 py-1 rounded w-full mb-3"
                                placeholder="Enter the new password"
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                disabled={apiLoading}
                              />
                              <label className="block mb-2 text-gray-600">Confirm Password</label>
                              <input
                                type="password"
                                className="border px-2 py-1 rounded w-full mb-4"
                                placeholder="Confirm your new password"
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                                disabled={apiLoading}
                              />
                              {apiError && <div className="text-red-600 mb-2">{apiError}</div>}
                              <button
                                className="bg-green-600 text-white px-4 py-2 rounded w-full disabled:bg-gray-200 disabled:text-gray-400"
                                onClick={handlePasswordSave}
                                disabled={apiLoading || !newPassword || !confirmPassword}
                              >
                                {apiLoading ? "Saving..." : "Save"}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
        </div>
    );
};

export default LoginScreen;
